<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M20.5 3a.404.404 0 0 0-.155.025L15 5.1 9 3 3.365 4.9A.509.509 0 0 0 3 5.38V20.5a.501.501 0 0 0 .655.475L9 18.9l6 2.1 5.64-1.895a.515.515 0 0 0 .36-.485V3.5c0-.275-.225-.5-.5-.5ZM15 19l-6-2.105V5l6 2.105V19Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="currentColor" d="M0 0h24v24H0z" /></clipPath>
    </defs>
  </svg>
</template>
